module.exports = __webpack_public_path__ + "fonts/LINESeedSans_A_Rg.6ef3094d.otf";